// Import required libraries
import React, { useState, useEffect, useReducer } from "react";
import axios from "axios";
import isEqual from "lodash.isequal";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeContext } from "../../../contexts/ThemeContext";

// Import custom components
import SigviewRadioGroup from "../../../components/Common/SigviewRadioGroup";
import SigviewTextField from "../../../components/Common/SigviewTextField";
import SigviewSingleSelect from "../../../components/Common/SigviewSingleSelect";
import SigviewTypography from "../../../components/Common/SigviewTypography";
import SigviewButton from "../../../components/Common/SigviewButton";
import SigviewInputTags from "../../../components/Common/SigviewInputTags";
import SigviewSwitch from "../../../components/Common/SigviewSwitch";
import SigviewNav from "../../../components/Common/SigviewNav";
import SelectedFilters from "../../../components/GlobalFilters/SelectedFilters";
import useReducerLogger from "../../../utils/useReducerLogger";

// Import utils/data
import { masterTrackGaEvent } from "../../../services/ga";
import { validateEmailAddress, getSigviewUserType } from "../../../utils/utils";
import {
  updateAlertForm,
  updateAlertFormDimensionRow,
  updateUserScreen,
  updateDialogInfo,
  replaceAllDimensionFilters,
} from "../../../redux/actions";
import dimensionFiltersReducer from "../../../redux/reducers/dimensionFilters";
import {
  validateAlertFormData,
  wrapper,
  alertFormData,
  getAllPlotlyMetrics,
  getAllPlotlyDimensions,
  unwrapperSummary,
  alertCriteriaFormula,
  getMetricTitleFormId,
  getNewAlertCriteriaRow,
} from "../../../utils/alertUtils";
import { config } from "../../../config/config";

// Import Api
import {
  createAlert,
  updateAlert,
  deleteAlert,
} from "../../../services/api/index";

//Import Styles
import "./AlertsSummary.scss";

// Making styles
const makeSigviewStyles = (...args) => {
  const [themeColors] = args;
  const useStyles = makeStyles(() => ({
    alertManagerFormRow: {
      marginBottom: "12px",
      "&.frequencyItemContainer": {
        display: "flex !important",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "12px",
      },
    },
    alertManagerFormItemContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      gap: "6px",
      paddingRight: "5px",
    },
    labelContainer: {
      // height: "16px",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "space-between",

      "&.commonSet": {
        // paddingTop: "7px",
      },

      "&.widthSet": {
        width: "20px !important",
        // paddingTop: "6px",
      },
      "&.alertEndsWidth": {
        width: "80px !important",
        // paddingTop: "6px",
        // paddingLeft: "30px",
      },
      "&.alertStatus": {
        width: "70px !important",
        // paddingTop: "7px",
        // paddingLeft: "30px",
      },
      "&.comparedWith": {
        width: "90px !important",
        paddingTop: "4px",
        // paddingLeft: "30px",
      },
      "&.alertMe": {
        // paddingBottom: "14px",
      },
    },
    label: {
      color: themeColors["secondaryColor"],
      fontSize: "12px",
      fontWeight: "500",
      //paddingTop: "5px",
      width: "110px",
    },
    inputItemContainer: {
      display: "flex",
      gap: "6px 8px",
      justifyContent: "flex-start",
      flexWrap: "wrap",
      alignItems: "center",
      //   paddingTop: "1px",

      "&.full": { width: "100%" },
      "&.inputContainer": {
        // backgroundColor: themeColors["secondaryColorLightest"],
        // border: `1px solid ${themeColors["secondaryColorLighter"]}`,
        borderRadius: "3px",
        boxSizing: "border-box",
      },
      "&.borderLess": {
        border: "none !important",
        // height: "24px",
        display: "flex",
        // flexDirection: "column",
      },
      "&.borderLessName": {
        border: "none !important",
        // height: "24px",
      },
      "&.radioBtnGroup": {
        // paddingTop: "7px",
      },
    },
    alertMeInputContainer: {
      display: "flex",
      gap: "6px 8px",
      // alignItems: "center",
      flexWrap: "wrap",
      // backgroundColor: "#fff",
      // padding: "13px 11px 0px 11px !important",
      borderRadius: "3px",
      boxSizing: "border-box",
      // border: "1px solid #edf1ff",
    },
  }));
  return useStyles;
};

// Defining required constants

const AlertCriteriaComponent = (props) => {
  // Destructure props
  const {
    changeCriteria,
    allMetrics,
    logicalConditionData,
    condition,
    state,
    showError,
    onChange = () => {},
  } = props;

  // Define required hooks
  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];

  const { alertCriteriaMetric } = state;

  let initialState = alertCriteriaMetric.value;
  // Defining the AlertCriteria reducer
  const [alertrowState, dispatch] = useReducer(
    useReducerLogger(reducer),
    initialState
  );
  //
  useEffect(() => {
    const payload = {
      value: alertCriteriaMetric.value,
    };
    const action = {
      type: "replace",
      payload,
    };
    let flag = !isEqual(alertrowState, alertCriteriaMetric.value);
    if (flag) {
      dispatch(action);
    }
  }, [alertCriteriaMetric.value]);

  // SideEffect for new change into alertrowState
  useEffect(() => {
    // console.log("sideEffects of componet change state", alertrowState);
    let flag = !isEqual(alertrowState, alertCriteriaMetric.value);
    if (flag) {
      onChange(alertrowState);
    }
  }, [alertrowState]);

  // This funcion cannot work without  state
  // function getCondition(value, id, alertrowState) {
  //   let data = alertrowState?.find((elm) => elm.id === id);

  //   if (value === "total") {
  //     return condition.absoluteComparison[0].id;
  //   } else if (value === "percentageChange") {
  //     return condition.relativeComparison[0].id;
  //   }
  //   return condition.relativeComparison[0].id;
  // }

  // Reducer function of AlertCriteriaComponent
  function reducer(alertrowState, action) {
    const { type, payload = {} } = action;
    const { key, value, id } = payload;

    let newData;

    switch (type) {
      case "UPDATE_METRIC_ALERT":
        switch (key) {
          case "changeCriteria":
          case "metric":
          case "conditionValue":
          case "logicalCondition":
            newData = alertrowState.map((el) => {
              if (el.id === id) {
                let newEl = el;
                if (value === "percentageChange") {
                  newEl = {
                    ...el,
                    condition: {
                      ...el.condition,
                      relativeComparison: {
                        message: "",
                        value: "increasesBy",
                        status: "valid",
                      },
                    },
                  };
                } else if (value === "total") {
                  newEl = {
                    ...el,
                    condition: {
                      ...el.condition,
                      absoluteComparison: {
                        message: "",
                        value: "isLessThan",
                        status: "valid",
                      },
                    },
                  };
                }

                return {
                  ...newEl,
                  [key]: { ...newEl[key], value },
                };
              } else return el;
            });
            break;
          case "absoluteComparison":
          case "relativeComparison":
            newData = alertrowState.map((el) =>
              el.id === id
                ? {
                    ...el,
                    ["condition"]: {
                      ...el["condition"],
                      [key]: {
                        ...el.condition[key],
                        value,
                      },
                    },
                  }
                : el
            );
            break;
          default:
            break;
        }
        break;

      case "deleteRow":
        if (alertrowState.length > 1) {
          newData = alertrowState.filter((el) => el.id !== id);
        }
        break;
      case "replace":
        newData = [...value];
        break;
      case "addRow":
        newData = [...alertrowState, getNewAlertCriteriaRow()];
        break;
      default:
        newData = [...alertrowState];
        break;
    }
    return newData;
  }

  // 2. ACTION CREATORS
  const handleChangeMetric = (action) => {
    dispatch(action);
  };

  // Making styles
  const makeSigviewStyles = () => {
    const useStyles = makeStyles(() => ({
      alertManagerFormRow: {
        // marginBottom: 25,
      },
      alertManagerFormItemContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        // minHeight: "40px !important",
        boxSizing: "border-box",
      },
      inputItemContainer: {
        display: "flex",
        justifyContent: "flex-start",
        flexWrap: "wrap",
        alignItems: "center",
        flexDirection: " column",
        width: "100%",
      },
      metricCriteriaRowContainer: {
        display: "flex",
        gap: "6px 8px",
        alignItems: "flex-start",
        flexWrap: "wrap",
        width: "100%",
      },
      metricCriteriaRow: {
        display: "flex",
        justifyContent: "flex-start",
        flexWrap: "wrap",
        flexDirection: "column",
        // marginRight: "10px",
      },
      alertMeInputContainer: {
        display: "flex",
        gap: "6px 8px",
        // alignItems: "center",
        flexWrap: "wrap",
        borderRadius: "3px",
        boxSizing: "border-box",
      },
    }));
    return useStyles;
  };

  // Destructuring variables from useStyles()
  const useSigviewStyles = makeSigviewStyles();
  let {
    alertManagerFormRow,
    alertManagerFormItemContainer,
    inputItemContainer,
    metricCriteriaRowContainer,
    metricCriteriaRow,
    alertMeInputContainer,
  } = useSigviewStyles();

  return (
    <div className={alertManagerFormRow}>
      <div className={alertManagerFormItemContainer}>
        <div className={inputItemContainer}>
          {alertrowState.map((el, index) => {
            const { id } = el;

            return (
              <div key={id} className={metricCriteriaRowContainer}>
                <div className={metricCriteriaRow}>
                  <div className={alertMeInputContainer}>
                    <Box>
                      <SigviewSingleSelect
                        value={el.changeCriteria.value}
                        data={changeCriteria}
                        minWidth="140px"
                        height="33px"
                        fontSize="12px"
                        // backgroundColor={`${themeColors["primaryColor"]}1A`}
                        backgroundColor="#EEEFF2"
                        border="none"
                        customClassName={`AlertMetric${el.changeCriteria.value}-GA`}
                        onChange={(newValue) => {
                          const payload = {
                            key: "changeCriteria",
                            value: newValue,
                            id,
                          };
                          const action = {
                            type: "UPDATE_METRIC_ALERT",
                            payload,
                          };

                          handleChangeMetric(action);
                        }}
                      />
                    </Box>
                    <Box>
                      <SigviewSingleSelect
                        value={el.metric.value}
                        data={allMetrics}
                        minWidth="140px"
                        height="33px"
                        fontSize="12px"
                        // backgroundColor={`${themeColors["primaryColor"]}1A`}
                        backgroundColor="#EEEFF2"
                        border="none"
                        onChange={(newValue) => {
                          const payload = {
                            key: "metric",
                            value: newValue,
                            id,
                          };
                          const action = {
                            type: "UPDATE_METRIC_ALERT",
                            payload,
                          };
                          handleChangeMetric(action);
                        }}
                        helperText="Select Metric cannot be empty"
                        error={
                          el.metric.value === "selectMetric" && showError.flag
                        }
                      />
                    </Box>
                    {(el.changeCriteria.value === "percentageChange" && (
                      <Box>
                        <SigviewSingleSelect
                          minWidth="140px"
                          height="33px"
                          fontSize="12px"
                          // backgroundColor={`${themeColors["primaryColor"]}1A`}
                          backgroundColor="#EEEFF2"
                          border="none"
                          value={el.condition.relativeComparison.value}
                          data={
                            alertFormData.alertCriteriaMetric.data.condition
                              .relativeComparison
                          }
                          maxWidth="120px"
                          onChange={(newValue) => {
                            const payload = {
                              key: "relativeComparison",
                              value: newValue,
                              id,
                            };
                            const action = {
                              type: "UPDATE_METRIC_ALERT",
                              payload,
                            };
                            handleChangeMetric(action);
                          }}
                        />
                      </Box>
                    )) || (
                      <Box>
                        <SigviewSingleSelect
                          minWidth="140px"
                          height="33px"
                          fontSize="12px"
                          // backgroundColor={`${themeColors["primaryColor"]}1A`}
                          backgroundColor="#EEEFF2"
                          border="none"
                          value={el.condition.absoluteComparison.value}
                          data={
                            alertFormData.alertCriteriaMetric.data.condition
                              .absoluteComparison
                          }
                          maxWidth="120px"
                          onChange={(newValue) => {
                            const payload = {
                              key: "absoluteComparison",
                              value: newValue,
                              id,
                            };
                            const action = {
                              type: "UPDATE_METRIC_ALERT",
                              payload,
                            };
                            handleChangeMetric(action);
                          }}
                        />
                      </Box>
                    )}

                    <Box>
                      <SigviewTextField
                        fontSize="12px"
                        height="33px"
                        border="none"
                        borderRadius="4px"
                        // backgroundColor={`${themeColors["primaryColor"]}1A`}
                        backgroundColor="#EEEFF2"
                        placeholder="Enter a Number"
                        type="number"
                        onChange={(newValue) => {
                          const payload = {
                            key: "conditionValue",
                            value: newValue,
                            id,
                          };
                          const action = {
                            type: "UPDATE_METRIC_ALERT",
                            payload,
                          };
                          handleChangeMetric(action);
                        }}
                        value={el.conditionValue.value}
                        maxWidth="120px"
                        minWidth="100px"
                        helperText="Threshold field cannot be empty"
                        error={!el.conditionValue.value && showError.flag}
                      />
                    </Box>
                    <div
                      className={
                        el.changeCriteria.value === "percentageChange"
                          ? "alerts-percent-sign percentageChangeON-GA"
                          : "alerts-no-percent-sign"
                      }
                    >
                      <SigviewTypography
                        variant="pSmallMedium"
                        style={{ height: "max-content" }}
                      >
                        %
                      </SigviewTypography>
                    </div>

                    {alertrowState.length > 1 && (
                      <Box
                        css={{ position: "relative" }}
                        onClick={(newValue) => {
                          const payload = { value: newValue, id };
                          const action = {
                            type: "deleteRow",
                            payload,
                          };
                          handleChangeMetric(action);
                        }}
                        className="material-icons-outlined alerts-delete-btn"
                      >
                        cancel
                      </Box>
                    )}
                  </div>
                  {alertrowState.length - 1 !== index && (
                    <div
                      className={`alerts-and-or-container ${
                        el.logicalCondition.value === "or"
                          ? "alerts-or-container"
                          : ""
                      }`}
                    >
                      <SigviewRadioGroup
                        value={el.logicalCondition.value}
                        data={logicalConditionData}
                        onChange={(newValue) => {
                          const payload = {
                            key: "logicalCondition",
                            value: newValue,
                            id,
                          };
                          const action = {
                            type: "UPDATE_METRIC_ALERT",
                            payload,
                          };
                          handleChangeMetric(action);
                        }}
                      />
                    </div>
                  )}
                </div>
                {alertrowState.length - 1 === index && (
                  <i
                    className="material-icons alerts-add-new-row-btn"
                    onClick={() => {
                      const payload = {};
                      const action = {
                        type: "addRow",
                        payload,
                      };
                      handleChangeMetric(action);
                    }}
                  >
                    add
                  </i>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

function AlertManagerSummary(props) {
  const { t } = useTranslation();
  // Destructure props
  const { state, allData } = props;
  // console.log(" STATE OF SUMMARY", props);

  // Define required hooks
  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];

  //Defining required functions
  const allplotlyDimension = allData.plotlyDimensions.map((row) => ({
    id: row._id,
    name: row._title,
    disabled: false,
  }));
  const allplotlyMetric = allData.plotlyMetrics.map((row) => ({
    id: row._id,
    name: row._title,
    dataUnitValue: row.dataUnit.value,
    disabled: false,
  }));

  // returning the name after giving id of metric and dimension
  // TODO: remove this code is not use here
  // function giveName(id, arr) {
  //   const row = arr.find((el) => el.id === id);
  //   return row;
  // }

  // function getMetricTitleFormId(id, arr) {
  //   const row = arr.find((el) => el.id === id);
  //   return row;
  // }

  const finalObj = unwrapperSummary(state);

  // Destructure finalObj
  const {
    name,
    alertMeWhen,
    alertDuration,
    alertCriteria,
    criteriaFormula,
    alertFilters,
    emailRecipients,
  } = finalObj;
  const { comparedWith, basis, timeZone } = alertMeWhen;

  // Defining required Components
  const AlertCriteria = () => {
    const { t } = useTranslation();
    const alertCompared = comparedWith ? ` ${comparedWith} ` : "";

    var result =
      state.alertType.value === "metric" &&
      alertCriteria.metric.map((obj) => {
        return obj.changeCriteria;
      });
    // console.log("result->", result);
    return (
      <>
        {state.alertType.value === "metric" && (
          <div className="alerts-me">
            <p className="alerts-me-metric">
              <span>{t("On")}</span>
              <span className="alerts-highlight">{t(basis)}</span>
              <span>{t("basis")}</span>
              {state.alertType.value === "metric"
                ? result.includes("Percentage Change") && (
                    <>
                      <span>{t("compared with")}</span>
                      <span className="alerts-highlight">{alertCompared}</span>
                    </>
                  )
                : ""}
              <span>{t("in")}</span>
              <span className="alerts-highlight">{timeZone}</span>
            </p>

            <p>{t("When")}</p>

            {state.alertType.value === "metric" &&
              alertCriteria.metric.map((obj, i) => {
                const {
                  changeCriteria,
                  metric,
                  condition,
                  conditionValue,
                  logicalCondition,
                } = obj;
                return (
                  <p className="alerts-me-metric">
                    {changeCriteria === "Percentage Change" && (
                      <>
                        <span className="alerts-highlight">
                          {t("Percentage Change")}
                        </span>
                        <span> {t("of")}</span>
                      </>
                    )}
                    {changeCriteria === "Total" && (
                      <span className="alerts-highlight">{t("Total")}</span>
                    )}
                    <span className="alerts-highlight">
                      {getMetricTitleFormId(metric, allplotlyMetric)?.name ||
                        "Select metric"}
                    </span>
                    <span className="alerts-highlight">{t(condition)}</span>
                    <span className="alerts-highlight">
                      {conditionValue || "Enter a number"}
                    </span>
                    {changeCriteria === "Percentage Change" && <span>%</span>}
                    {i != alertCriteria.metric.length - 1 && (
                      <span className="alerts-logic">
                        {t(logicalCondition.toUpperCase())}
                      </span>
                    )}
                  </p>
                );
              })}
          </div>
        )}
        {state.alertType.value === "dimension" && (
          <div className="alerts-me">
            <Dimension />
          </div>
        )}
      </>
    );
  };
  const Dimension = () => {
    // changeCriteria: "Total"
    // condition: "Is Equal to"
    // conditionValue: ""
    // dimension: "selectDimension"
    // dimensionRow: "change"
    // group: "Top 10"
    // metric: "selectMetric"

    const {
      changeCriteria,
      condition,
      conditionValue,
      dimension,
      dimensionRow,
      group,
      metric,
    } = alertCriteria.dimension;
    return (
      <>
        {dimensionRow === "change" && (
          <p className="alerts-me-dimension">
            <span>{t("If")}</span>
            <span className="alerts-highlight">{t(changeCriteria)}</span>
            <span className="alerts-highlight">
              {getMetricTitleFormId(metric, allplotlyMetric)?.name ||
                "Select metric"}
            </span>
            <span>{t("for")}</span>
            <span className="alerts-highlight">{t(group)}</span>
            <span className="alerts-highlight">
              {getMetricTitleFormId(dimension, allplotlyDimension)?.name ||
                "Select dimension"}
            </span>
            <span>{t("is")}</span>
            <span className="alerts-highlight">{t(condition)}</span>
            <span className="alerts-highlight">{conditionValue}</span>
            {changeCriteria === "Percentage Change" && <span>{" % "}</span>}
            {changeCriteria === "Percentage Change" && (
              <>
                <span>{t("Compared With")}</span>
                <span className="alerts-highlight">{t(comparedWith)}</span>
              </>
            )}
            <span>{t("For Timezone")}</span>
            <span className="alerts-highlight"> {timeZone}</span>
            <span>{t("On")}</span>
            <span className="alerts-highlight">{t(basis)}</span>{" "}
            <span>{t("basis")}</span>
          </p>
        )}
        {dimensionRow === "add" && (
          <p className="alerts-me-dimension">
            <span>{t("If There is a new value in")}</span>
            <span className="alerts-highlight">
              {getMetricTitleFormId(dimension, allplotlyDimension)?.name ||
                "Select dimension"}
            </span>
            <span>{t("Compared With")}</span>
            <span className="alerts-highlight">{comparedWith}</span>
            <span>{t("For Timezone")}</span>
            <span className="alerts-highlight"> {timeZone}</span>
            <span>{t("On")}</span>
            <span className="alerts-highlight">{t(basis)}</span>
            <span>{t("basis")}</span>
          </p>
        )}
        {dimensionRow === "delete" && (
          <p className="alerts-me-dimension">
            <span>{t("If Any value for")}</span>
            <span className="alerts-highlight">
              {getMetricTitleFormId(dimension, allplotlyDimension)?.name ||
                "Select dimension"}
            </span>
            <span>{t("value was dropped ")}</span>
            <span>{t("Compared With")}</span>
            <span className="alerts-highlight">{t(comparedWith)}</span>
            <span>{t("For Timezone")}</span>
            <span className="alerts-highlight"> {timeZone}</span>
            <span>{t("On")}</span>
            <span className="alerts-highlight">{t(basis)}</span>
            <span>{t("basis")}</span>
          </p>
        )}
      </>
    );
  };
  const AlertCriteriaFormula = () => {
    // console.log("row criteriaFormula", criteriaFormula);
    const finalFormulaeFormUtils = alertCriteriaFormula({ state, allData });
    return (
      <>
        <div className="alerts-criteria-formula">
          <p>{finalFormulaeFormUtils}</p>
        </div>
      </>
    );
  };
  // console.log("Alert summary->", state);

  //! to be improved
  const summarystyle = {
    // pointerEvents: "none",
    height: "max-content",
    width: "98%",
    border: "1px solid ##edf1ff",
    padding: "7px",
    marginTop: "5px",
    borderRadius: "4px",
    minHeight: "24px",
    boxSizing: "border-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    backgroundColor: "var(--popoverBgColor)",
    color: "var(--secondaryColor)",
    display: "flex",
  };

  //* Defining required variables
  const showFilterRow = alertFilters.length > 0 ? true : false;
  // console.log("alertfilters", alertFilters);
  return (
    <>
      <div className="alerts-summary-container">
        <div className="alerts-summary-items">
          <p
            style={{
              color: themeColors["secondaryColor"],
              fontSize: "12px",
              fontWeight: "400",
            }}
            className="alerts-label"
          >
            {t("Name:")}
          </p>
          <div style={summarystyle}>
            <SigviewTypography variant="AlertSummaryTitle">
              {name}
            </SigviewTypography>
          </div>
        </div>
        <div className="alerts-summary-items">
          <p
            style={{
              color: themeColors["secondaryColor"],
              fontSize: "12px",
              fontWeight: "400",
            }}
            className="alerts-label"
          >
            {t("Alert Me:")}
          </p>
          <div className="alerts-me-container" style={summarystyle}>
            {/* <SigviewTypography
              variant="AlertSummaryTitle"
              style={{
                height: "auto",
              }}
            >
              {" "}
            </SigviewTypography> */}
            <span
              style={{
                fontSize: "12px",
              }}
            >
              <AlertCriteria />
            </span>{" "}
          </div>
        </div>
        {state.alertType.value === "metric" && (
          <div className="alerts-summary-items">
            <p
              style={{
                color: themeColors["secondaryColor"],
                fontSize: "12px",
                fontWeight: "400",
              }}
              className="alerts-label"
            >
              {t("Criteria Formula:")}
            </p>

            <div style={summarystyle}>
              {/* <SigviewTypography variant="AlertSummaryTitle"></SigviewTypography> */}
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                <AlertCriteriaFormula />
              </span>{" "}
            </div>
          </div>
        )}
        {showFilterRow && (
          <div className="alerts-summary-items">
            <p
              style={{
                color: themeColors["secondaryColor"],
                fontSize: "12px",
                fontWeight: "400",
              }}
              className="alerts-label"
            >
              {t("Filter:")}
            </p>

            <div style={summarystyle}>
              <SelectedFilters
                style={{ maxHeight: "62px" }}
                selectedDimensionFilters={[...alertFilters]}
                allData={allData}
                disableClick={true}
                isReadOnly={true}
              />
            </div>
          </div>
        )}
        {/* <div className="alerts-summary-items">
          <p className="alerts-label">Filter:</p>

          <div style={summarystyle}>
            <SigviewTypography variant="AlertSummaryTitle">
              {includeFilters}
            </SigviewTypography>
          </div>
        </div> */}
        {/* <div className="alerts-summary-items">
          <p className="alerts-label">Exclude Filter:</p>

          <div style={summarystyle}>
            <SigviewTypography variant="AlertSummaryTitle">
              {excludeFilters}
            </SigviewTypography>
          </div>
        </div> */}
        <div className="alerts-summary-items">
          <p
            style={{
              color: themeColors["secondaryColor"],
              fontSize: "12px",
              fontWeight: "400",
            }}
            className="alerts-label"
          >
            {t("Alert Ends in:")}
          </p>

          <div style={summarystyle}>
            <SigviewTypography variant="AlertSummaryTitle">
              {alertDuration}
            </SigviewTypography>
          </div>
        </div>

        <div className="alerts-summary-items">
          <p
            style={{
              color: themeColors["secondaryColor"],
              fontSize: "12px",
              fontWeight: "400",
            }}
            className="alerts-label"
          >
            {t("Email Recipients:")}
          </p>
          <div style={summarystyle}>
            <SigviewTypography variant="AlertSummaryTitle">
              {emailRecipients.map((el) => el).join(", ")}
            </SigviewTypography>
          </div>
        </div>
      </div>{" "}
    </>
  );
}

function AlertManagerFormRowItem(props) {
  // Define required hooks
  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];

  // Destructure props
  const {
    title = "",
    children = <></>,
    style = {},
    buttonProps = {},
    buttonFlag = false,
  } = props;
  const {
    iconProps = {},
    title: buttonTitle = "Add",
    onClick: buttonOnClick = () => {},
  } = buttonProps;
  // Destructuring variables from useStyles()
  const useSigviewStyles = makeSigviewStyles(themeColors);
  let {
    alertManagerFormItemContainer,
    labelContainer,
    label,
    inputItemContainer,
  } = useSigviewStyles();

  // Adding required classes based on props
  if (style.full) inputItemContainer += " full";
  if (style.inputContainer) inputItemContainer += " inputContainer";
  if (style.borderLess) inputItemContainer += " borderLess";
  if (style.widthSet) labelContainer += " widthSet";
  if (style.alertEndsWidth) labelContainer += " alertEndsWidth";
  if (style.alertStatus) labelContainer += " alertStatus";
  if (style.comparedWith) labelContainer += " comparedWith";
  if (style.radioBtnGroup) inputItemContainer += " radioBtnGroup";
  if (style.alertMe) labelContainer += " alertMe";
  if (style.commonSet) labelContainer += " commonSet";
  if (style.borderLessName) inputItemContainer += " borderLessName";

  return (
    <div className={alertManagerFormItemContainer}>
      <div className={labelContainer}>
        <p className={label}>{title}</p>
        {buttonFlag && (
          <SigviewButton
            variant="containedPrimary"
            title={buttonTitle}
            onClick={buttonOnClick}
            iconProps={iconProps}
            iconFlag={true}
            iconStyle={{ fontSize: "13px", margin: "2px 0px" }}
            style={{ padding: "4px 10px", buttonHeight: "22px" }}
          />
        )}
      </div>
      <div className={inputItemContainer}>{children}</div>
    </div>
  );
}

function AlertManagerFormRow(props) {
  // Destructure props
  const { children = {}, style = {} } = props;

  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];

  // Destructuring variables from useStyles()
  const useSigviewStyles = makeSigviewStyles(themeColors);
  let { alertManagerFormRow } = useSigviewStyles();
  if (style.frequencyItemContainer)
    alertManagerFormRow += " frequencyItemContainer";

  return <div className={alertManagerFormRow}>{children}</div>;
}

const AlertDimension = (props = {}) => {
  const { t } = useTranslation();
  const {
    dispatch,
    state,
    allData,
    validMetric,
    showError,
    validDimension,
    validConditionValue,
  } = props;

  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];

  // Destructuring variables from useStyles()
  const useSigviewStyles = makeSigviewStyles(themeColors);
  let { alertMeInputContainer } = useSigviewStyles();

  const sigviewUserType = getSigviewUserType();

  const handleAlertMeDimension = (newValue) => {
    // reducer dispatch action with value
    const payload = { key: "dimensionRow", value: newValue };
    const action = updateAlertFormDimensionRow(payload);
    dispatch(action);
  };
  const optionOneSelected =
    state.alertCriteriaDimension.value.dimensionRow.value === "change";
  const optionTwoSelected =
    state.alertCriteriaDimension.value.dimensionRow.value === "add";
  const optionThreeSelected =
    state.alertCriteriaDimension.value.dimensionRow.value === "delete";
  return (
    <>
      <AlertManagerFormRowItem
        style={{ height: "2px", alertMe: true }}
        title="Alert Me:"
      >
        <div className={alertMeInputContainer}>
          <Box style={{ padding: "4.5px 0px" }}>
            <SigviewRadioGroup
              data={
                alertFormData.alertCriteriaDimension.data.dimensionRow.change
              }
              onChange={(newValue) => handleAlertMeDimension(newValue)}
              value={state.alertCriteriaDimension.value.dimensionRow.value}
              customClassName={`AlertMeClick-${state.alertCriteriaDimension.value.dimensionRow.value}-GA`}
              style={{ fontSize: "12px" }}
            />
          </Box>

          <Box style={{ padding: "11px 0px" }}>
            <SigviewTypography
              style={{
                height: "max-content",
              }}
              variant="pMedium"
            >
              If
            </SigviewTypography>
          </Box>
          <Box>
            <SigviewSingleSelect
              value={state.alertCriteriaDimension.value.changeCriteria.value}
              data={alertFormData.alertCriteriaDimension.data.changeCriteria}
              onChange={(newValue) => {
                // reducer dispatch action with value
                const payload = { key: "changeCriteria", value: newValue };
                const action = updateAlertFormDimensionRow(payload);
                dispatch(action);
              }}
              disabled={!optionOneSelected}
              minWidth="140px"
              height="33px"
              fontSize="12px"
              // backgroundColor={`${themeColors["primaryColor"]}1A`}
              backgroundColor="#EEEFF2"
              border="none"
              customClassName={`AlertDimension${state.alertCriteriaDimension.value.changeCriteria.value}-GA`}
            />
          </Box>
          <Box>
            <SigviewSingleSelect
              value={state.alertCriteriaDimension.value.metric.value}
              data={getAllPlotlyMetrics(allData)}
              onChange={(newValue) => {
                // reducer dispatch action with value
                const payload = { key: "metric", value: newValue };
                const action = updateAlertFormDimensionRow(payload);
                dispatch(action);
              }}
              helperText="Select Metric cannot be empty"
              disabled={!optionOneSelected}
              error={validMetric && optionOneSelected && showError.flag}
              minWidth="140px"
              height="33px"
              fontSize="12px"
              border="none"
              // backgroundColor={`${themeColors["primaryColor"]}1A`}
              backgroundColor="#EEEFF2"
            />
          </Box>

          <Box style={{ padding: "11px 0px" }}>
            <SigviewTypography
              style={{
                height: "max-content",
              }}
              variant="pSmallMedium"
            >
              for
            </SigviewTypography>
          </Box>

          <Box>
            <SigviewSingleSelect
              value={state.alertCriteriaDimension.value.group.value}
              data={alertFormData.alertCriteriaDimension.data.groupComparison}
              onChange={(newValue) => {
                // reducer dispatch action with value
                const payload = { key: "group", value: newValue };
                const action = updateAlertFormDimensionRow(payload);
                dispatch(action);
              }}
              disabled={!optionOneSelected}
              minWidth="80px"
              width="80px"
              height="33px"
              fontSize="12px"
              border="none"
              // backgroundColor={`${themeColors["primaryColor"]}1A`}
              backgroundColor="#EEEFF2"
            />
          </Box>
          <Box>
            <SigviewSingleSelect
              value={state.alertCriteriaDimension.value.dimensionChange.value}
              data={getAllPlotlyDimensions(allData)}
              onChange={(newValue) => {
                // reducer dispatch action with value
                const payload = { key: "dimensionChange", value: newValue };
                const action = updateAlertFormDimensionRow(payload);
                dispatch(action);
              }}
              helperText="Select Dimension cannot be empty"
              disabled={!optionOneSelected}
              error={validDimension && optionOneSelected && showError.flag}
              minWidth="140px"
              height="33px"
              fontSize="12px"
              border="none"
              // backgroundColor={`${themeColors["primaryColor"]}1A`}
              backgroundColor="#EEEFF2"
            />
          </Box>

          {
            <>
              {(state.alertCriteriaDimension.value.changeCriteria.value ===
                "percentageChange" && (
                <Box>
                  <SigviewSingleSelect
                    value={
                      state.alertCriteriaDimension.value.condition
                        .relativeComparison.value
                    }
                    data={
                      alertFormData.alertCriteriaDimension.data.condition
                        .relativeComparison
                    }
                    //TODO:
                    onChange={(newValue) => {
                      // reducer dispatch action with value
                      const payload = {
                        key: "relativeComparison",
                        value: newValue,
                      };
                      const action = updateAlertFormDimensionRow(payload);
                      dispatch(action);
                    }}
                    disabled={!optionOneSelected}
                    minWidth="140px"
                    height="33px"
                    fontSize="12px"
                    border="none"
                    // backgroundColor={`${themeColors["primaryColor"]}1A`}
                    backgroundColor="#EEEFF2"
                  />
                </Box>
              )) || (
                <Box>
                  <SigviewSingleSelect
                    value={
                      state.alertCriteriaDimension.value.condition
                        .absoluteComparison.value
                    }
                    data={
                      alertFormData.alertCriteriaDimension.data.condition
                        .absoluteComparison
                    }
                    //TODO:
                    onChange={(newValue) => {
                      // reducer dispatch action with value
                      const payload = {
                        key: "absoluteComparison",
                        value: newValue,
                      };
                      const action = updateAlertFormDimensionRow(payload);
                      dispatch(action);
                    }}
                    disabled={!optionOneSelected}
                    minWidth="140px"
                    //maxWidth="100px"
                    height="33px"
                    fontSize="12px"
                    border="none"
                    // backgroundColor={`${themeColors["primaryColor"]}1A`}
                    backgroundColor="#EEEFF2"
                  />
                </Box>
              )}
            </>
          }

          <Box>
            <SigviewTextField
              placeholder="Enter a Number"
              type="number"
              onChange={(newValue) => {
                // reducer dispatch action with value

                const payload = {
                  key: "conditionValue",
                  value: newValue,
                };
                const action = updateAlertFormDimensionRow(payload);
                dispatch(action);
              }}
              value={state.alertCriteriaDimension.value.conditionValue.value}
              disabled={!optionOneSelected}
              readOnly={!optionOneSelected}
              error={validConditionValue && optionOneSelected && showError.flag}
              helperText={
                validConditionValue && "Threshold field cannot be empty"
              }
              minWidth="140px"
              height="33px"
              fontSize="12px"
              border="none"
              // backgroundColor={`${themeColors["primaryColor"]}1A`}
              backgroundColor="#EEEFF2"
            />
          </Box>

          {state.alertCriteriaDimension.value.changeCriteria.value ===
            "percentageChange" && (
            <Box>
              <SigviewTypography
                style={{
                  height: "max-content",
                }}
                variant="pSmallMedium"
              >
                %
              </SigviewTypography>
            </Box>
          )}
        </div>
      </AlertManagerFormRowItem>

      <AlertManagerFormRowItem>
        <div className={alertMeInputContainer}>
          <Box style={{ padding: "4.5px 0px" }}>
            <SigviewRadioGroup
              data={alertFormData.alertCriteriaDimension.data.dimensionRow.add}
              onChange={(newValue) => {
                // reducer dispatch action with value
                const payload = {
                  key: "dimensionRow",
                  value: newValue,
                };
                const action = updateAlertFormDimensionRow(payload);
                dispatch(action);
              }}
              value={state.alertCriteriaDimension.value.dimensionRow.value}
              style={{ fontSize: "12px" }}
            />
          </Box>
          <Box style={{ padding: "11px 0px" }}>
            <SigviewTypography
              style={{
                height: "max-content",
              }}
              variant="pMedium"
            >
              If there is a new value in
            </SigviewTypography>
          </Box>
          <Box>
            <SigviewSingleSelect
              value={state.alertCriteriaDimension.value.dimensionAdd.value}
              data={getAllPlotlyDimensions(allData)}
              onChange={(newValue) => {
                // reducer dispatch action with value
                const payload = {
                  key: "dimensionAdd",
                  value: newValue,
                };
                const action = updateAlertFormDimensionRow(payload);
                dispatch(action);
              }}
              helperText="Select Dimension cannot be empty"
              disabled={!optionTwoSelected}
              error={validDimension && optionTwoSelected && showError.flag}
              minWidth="180px"
              height="33px"
              fontSize="12px"
              border="none"
              // backgroundColor={`${themeColors["primaryColor"]}1A`}
              backgroundColor="#EEEFF2"
            />
          </Box>
        </div>
      </AlertManagerFormRowItem>

      <AlertManagerFormRowItem>
        <div className={alertMeInputContainer}>
          <Box style={{padding: "4.5px 0px"}}>
            <SigviewRadioGroup
              data={
                alertFormData.alertCriteriaDimension.data.dimensionRow.delete
              }
              onChange={(newValue) => {
                // reducer dispatch action with value
                const payload = {
                  key: "dimensionRow",
                  value: newValue,
                };
                const action = updateAlertFormDimensionRow(payload);
                dispatch(action);
              }}
              value={state.alertCriteriaDimension.value.dimensionRow.value}
              style={{ fontSize: "12px" }}
            />
          </Box>

          <Box style={{padding: "11px 0px"}}>
            <SigviewTypography
              style={{
                height: "max-content",
              }}
              variant="pMedium"
            >
              If there was a value dropped in
            </SigviewTypography>
          </Box>

          <Box>
            <SigviewSingleSelect
              value={state.alertCriteriaDimension.value.dimensionDelete.value}
              data={getAllPlotlyDimensions(allData)}
              onChange={(newValue) => {
                // reducer dispatch action with value
                const payload = {
                  key: "dimensionDelete",
                  value: newValue,
                };
                const action = updateAlertFormDimensionRow(payload);
                dispatch(action);
              }}
              helperText="Select Dimension cannot be empty"
              disabled={!optionThreeSelected}
              error={validDimension && optionThreeSelected && showError.flag}
              minWidth="180px"
              height="33px"
              fontSize="12px"
              border="none"
              // backgroundColor={`${themeColors["primaryColor"]}1A`}
              backgroundColor="#EEEFF2"
            />
          </Box>
        </div>
      </AlertManagerFormRowItem>
    </>
  );
};

function AlertManagerForm(props) {
  // Destructure props
  const {
    state,
    dispatch,
    ReduxDispatcher,
    user,
    globalFilters,
    allData,
    setShowAlertManager,
    reloadData,
    setReloadData,
    alertFormDataOriginal,
    activeAlertNav,
    setActiveAlertNav,
    setSelectedAlertId,
    alertsName,
  } = props;

  // Define required hooks
  const { t } = useTranslation();
  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];

  // * Defining required states
  const [showError, setShowError] = useState({
    flag: false,
  });

  const pathname = window.location.pathname;
  const rootPage = pathname.split("/")[1];

  // Validate the alert form state
  const validate = validateAlertFormData(state);

  // * Define required variables
  const dimensionFiltersSettings = {
    isAdvancedFilterVisible: true,
    isExcludeAllowed: true,
    disabledItemsList: [], // ["D044"] --> This needs to be a array of ids
  };

  //Name field  validation flag
  const sigviewUserType = getSigviewUserType();

  const checkSpecialChar = (value) => {
    if (sigviewUserType === "sigview") return !/^[A-z0-9-_]*$/.test(value);
    else
      return !/^[a-zA-Z0-9-_!@#$%^&*()+=~|:;',./<>? \u3040-\u309F\u30A0-\u30FF-\u31F0-\u31FF-\u2E80-\u2EFF-\u2F00-\u2FDF-\u3000-\u303F-\u31C0-\u31EF-\u3200-\u32FF-\u3300-\u33FF-\u3400-\u3FFF-\u4000-\u4DBF-\u4E00-\u4FFF]*$/.test(
        state.name.value
      );
  };

  const validateName =
    state.name.value.trim() === "" ||
    state.name.value.length === 0 ||
    state.name.value.length > 100 ||
    checkSpecialChar(state.name.value);

  const validateNameMessage = (value) => {
    const runFlagCheck =
      sigviewUserType === "sigview"
        ? !/^[A-z0-9-_ ]*$/.test(value)
        : !/^[a-zA-Z0-9-_!@#$%^&*()+=~|:;',./<>? \u3040-\u309F\u30A0-\u30FF-\u31F0-\u31FF-\u2E80-\u2EFF-\u2F00-\u2FDF-\u3000-\u303F-\u31C0-\u31EF-\u3200-\u32FF-\u3300-\u33FF-\u3400-\u3FFF-\u4000-\u4DBF-\u4E00-\u4FFF]*$/.test(
            value
          );

    if (runFlagCheck) {
      return "Alert name cannot have special characters";
    } else if (state.name.value.trim() === "") {
      return "Name must have at least 1 character";
    } else if (state.name.value.length > 100) {
      return "Name cannot be more than 100 character";
    }
  };

  //validation in dimension alert on change dimension input feild is empty or not
  const validConditionValue =
    !state.alertCriteriaDimension.value.conditionValue.value;
  // console.error("validConditionValue", validConditionValue);
  //In dimension alert to select the options (change/add/delete) valid metric and dimension flag
  const optionOneSelected =
    state.alertCriteriaDimension.value.dimensionRow.value === "change";
  const optionTwoSelected =
    state.alertCriteriaDimension.value.dimensionRow.value === "add";
  const optionThreeSelected =
    state.alertCriteriaDimension.value.dimensionRow.value === "delete";

  // Validation for in dimesion alert any of the dimension row is selected or not
  const validDimension = optionOneSelected
    ? state.alertCriteriaDimension.value.dimensionChange.value ===
      "selectDimension"
    : optionTwoSelected
    ? state.alertCriteriaDimension.value.dimensionAdd.value ===
      "selectDimension"
    : optionThreeSelected
    ? state.alertCriteriaDimension.value.dimensionDelete.value ===
      "selectDimension"
    : console.log("Wrong Input");

  //validation in dimension alert on change dimension metric feild is empty or not
  const validMetric =
    state.alertCriteriaDimension.value.metric.value === "selectMetric";

  //Email validation function
  const validateEmail = (text) => {
    const recipientsList = state.emailRecipients.value.map((row) => row.name);
    if (!validateEmailAddress(text))
      return { isValid: false, message: "Invalid email address" };
    if (recipientsList.includes(text))
      return { isValid: false, message: "Duplicate email address" };
    return { isValid: true, message: "" };
  };

  // Run on clicking add filters
  // Global Filters Event Handlers

  const handleDimensionFiltersChange = (value) => {
    var payload = { key: "dimensionFilters", value };
    const action = updateAlertForm(payload);
    dispatch(action);
  };

  const handleAddFilters = () => {
    const handleApplyFilters = (payload, filterType) => {
      switch (filterType) {
        case "dimensions":
          var action = replaceAllDimensionFilters(payload);
          var newDimensionFilters = dimensionFiltersReducer(
            payload.newDimensionFilters,
            action
          );
          handleDimensionFiltersChange(newDimensionFilters);
          break;
        // case "metrics":
        //   var action = replaceAllMetricFilters(payload);
        //   dispatchMetricFilters(action);
        //   break;
        // case "time":
        //   onTimeFiltersChange(payload);
        //   break;
      }
    };

    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "GlobalFilters",
      action: "Open Filters",
      label: "Sidenav",
    });
    const commonGlobalFilterProps = {
      isOpen: true, //global filters dialog open close
      showTimeFilters: false,
      showMetricFilters: false,
      activeFilterType: "dimensions",
      isAdFiltersOpen: false, //advanced filters dialog open close
      timeFilters: user.timeFilters, //for initializing filters
      dimensionFilters: state.dimensionFilters.value, //for initializing filters
      metricFilters: [], //for initializing filters
      settings: dimensionFiltersSettings,
      filtersDimData: allData.plotlyDimensions,
      filtersMetricsData: allData.plotlyMetrics,
      selections: {},
    };
    //Open Global Filters
    const newGlobalFiltersProps = {
      ...commonGlobalFilterProps,
      activeDimensionFilter: {},
      handleApplyFilters, //It will take 2 parameters, payload and filterType (dimensions or metric or time); We have 2 separate actions for both
    };

    const action = updateUserScreen("globalFilters", newGlobalFiltersProps);
    ReduxDispatcher(action);
  };

  const handleDimFilterClick = (filterRow) => {
    //Open Global Filters
    const newGlobalFiltersProps = {
      isOpen: true, //global filters dialog open close
      showTimeFilters: false,
      showMetricFilters: false,
      activeFilterType: "dimensions",
      isAdFiltersOpen: false, //advanced filters dialog open close
      activeDimensionFilter: filterRow.metadata,
      timeFilters: user.timeFilters, //for initializing filters
      dimensionFilters: state.dimensionFilters.value, //for initializing filters
      metricFilters: [], //for initializing filters
      handleApplyFilters: (payload, filterType) => {
        switch (filterType) {
          case "dimensions":
            const actionPayload = {
              key: "dimensionFilters",
              value: payload.newDimensionFilters,
            };
            const action = updateAlertForm(actionPayload);
            dispatch(action);
            break;
          case "metrics":
            break;
          case "time":
            break;
        }
      }, //It will take 2 parameters, payload and filterType (dimensions or metric or time); We have 2 separate actions for both
    };
    ReduxDispatcher(updateUserScreen("globalFilters", newGlobalFiltersProps));
  };

  const handleDimFilterDelete = (filterRow) => {
    const newDimFilters = state.dimensionFilters.value.filter(
      (filter) => filter.id !== filterRow.id
    );
    const actionPayload = {
      key: "dimensionFilters",
      value: newDimFilters,
    };
    const action = updateAlertForm(actionPayload);
    dispatch(action);
  };

  const handleClearAllFilters = () => {
    const actionPayload = {
      key: "dimensionFilters",
      value: [],
    };
    const action = updateAlertForm(actionPayload);
    dispatch(action);
  };

  // Cancel event listener
  // Run on clicking the cancel button form alert manager form
  const handleCancel = () => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "AlertManager",
      action: "AlertCURD",
      label: "cancel",
    });

    //Check if there's a change in alert form data and state
    //If yes, show the dialog, else close the active report
    const flag = !isEqual(state, alertFormDataOriginal.current);

    if (flag) {
      const message = {
        title: "Discard Changes?",
        subtitle: "This action cannot be undone",
      };
      const handleNo = () => {
        //Close the dialog box
        ReduxDispatcher(
          updateDialogInfo({
            ...user.dialogInfo,
            open: false,
          })
        );
      };
      const handleYes = () => {
        //Close the dialog box
        ReduxDispatcher(
          updateDialogInfo({
            ...user.dialogInfo,
            open: false,
            message: { title: "", subtitle: "" },
          })
        );

        //Close the active alert
        setShowAlertManager(false);
      };
      ReduxDispatcher(
        updateDialogInfo({
          ...user.dialogInfo,
          open: true,
          message,
          handleYes,
          handleNo,
        })
      );
    } else {
      //Close the active alert
      setShowAlertManager(false);
      // resetting the selected alert id
      setSelectedAlertId(null);
    }
  };

  // Update event listener
  // Run on clicking  update button
  const handleUpdate = () => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "AlertManager",
      action: "AlertCURD",
      label: "update",
    });

    const isAlertFormDataValidFlag = validateAlertFormData(state);
    // if validate is true then disable the save button
    if (isAlertFormDataValidFlag) {
      setShowError({ ...showError, flag: true });
    } else {
      //Update snackbar
      let snackbarPayload = {
        ...user.screen.snackbar,
        open: true,
        message: "Requesting update Alert",
      };
      ReduxDispatcher(updateUserScreen("snackbar", snackbarPayload));

      const payload = wrapper(
        { ...state },
        user?.reqMetadata?.email,
        allData,
        globalFilters
      );
      const source = axios.CancelToken.source();
      const fetchProps = {
        cancelToken: source.token,
        payload,
      };
      const updateAlertPromise = updateAlert(fetchProps);
      updateAlertPromise
        .then(() => {
          //Update snackbar
          let snackbarPayload = {
            ...user.screen.snackbar,
            open: true,
            message: "Alert updated sucessfully",
          };
          ReduxDispatcher(updateUserScreen("snackbar", snackbarPayload));
          setShowAlertManager(false);
          // resetting the selected alert id
          setSelectedAlertId(null);
          setReloadData(!reloadData);
        })
        .catch((json) => {
          console.log("API FAILED", json);

          let snackbarPayload = {
            ...user.screen.snackbar,
            open: true,
            message: json.error || "Requesting Updating Alert",
          };
          ReduxDispatcher(updateUserScreen("snackbar", snackbarPayload));
        });
    }
  };
  // Delete event listener
  // Run on clicking  delete button
  const handleDelete = () => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "AlertManager",
      action: "AlertCURD",
      label: "delete",
    });

    const message = {
      title: `Are you sure you want to delete?`,
      subtitle: "",
    };

    const handleNo = () => {
      //Close the dialog box
      ReduxDispatcher(
        updateDialogInfo({
          ...user.dialogInfo,
          open: false,
        })
      );
    };

    const handleYes = () => {
      //Close the dialog box
      ReduxDispatcher(
        updateDialogInfo({
          ...user.dialogInfo,
          open: false,
          message: { title: "", subtitle: "" },
        })
      );

      //Update snackbar
      let snackbarPayload = {
        ...user.screen.snackbar,
        open: true,
        message: "Requesting deleting Alert",
      };
      ReduxDispatcher(updateUserScreen("snackbar", snackbarPayload));

      // Alert id to be deleted
      const alert_id = state.id.value;
      const fetchProps = {
        alert_id,
      };

      const deleteSavedAlertPromise = deleteAlert(fetchProps);
      deleteSavedAlertPromise
        .then(() => {
          //Update snackbar
          let snackbarPayload = {
            ...user.screen.snackbar,
            open: true,
            message: "Alert deleted sucessfully",
          };
          ReduxDispatcher(updateUserScreen("snackbar", snackbarPayload));
          setShowAlertManager(false);
          setReloadData(!reloadData);
        })
        .catch((json) => {
          console.log("API FAILED", json);

          let snackbarPayload = {
            ...user.screen.snackbar,
            open: true,
            message: json.error || "Requesting deleting Alert",
          };
          ReduxDispatcher(updateUserScreen("snackbar", snackbarPayload));
        });
    };
    ReduxDispatcher(
      updateDialogInfo({
        ...user.dialogInfo,
        open: true,
        message,
        handleYes,
        handleNo,
      })
    );
  };

  // Save event listener
  // Run on clicking  save button
  const handleSave = () => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "AlertManager",
      action: "AlertCURD",
      label: "save",
    });

    const isAlertFormDataValidFlag = validateAlertFormData(state);
    // if validate is true then disable the save button

    if (isAlertFormDataValidFlag) {
      setShowError({ ...showError, flag: true });
    } else {
      //Update snackbar
      let snackbarPayload = {
        ...user.screen.snackbar,
        open: true,
        message: "Requesting to saved alert...",
      };
      ReduxDispatcher(updateUserScreen("snackbar", snackbarPayload));

      // if isAlertFormDataValidFlag is false then the form is correctly filled and call the api
      //! Add patterns
      //Make fetch call using axios
      const payload = wrapper(
        { ...state },
        user?.reqMetadata?.email,
        allData,
        globalFilters
      );
      const source = axios.CancelToken.source();
      const fetchProps = {
        cancelToken: source.token,
        payload,
      };
      const createAlertPromise = createAlert(fetchProps);
      createAlertPromise
        .then((responseData) => {
          // TODO: Change when backend DS is corrected
          if (responseData.status.statusCode === "200") {
            //Update snackbar
            let snackbarPayload = {
              ...user.screen.snackbar,
              open: true,
              message: "Alert has been saved sucessfully",
            };
            ReduxDispatcher(updateUserScreen("snackbar", snackbarPayload));
            setShowAlertManager(false);
            setReloadData(!reloadData);
          } else {
            console.groupCollapsed("API ERROR");
            console.groupEnd();

            let snackbarPayload = {
              ...user.screen.snackbar,
              open: true,
              message: responseData.status.statusMessage,
            };
            ReduxDispatcher(updateUserScreen("snackbar", snackbarPayload));
          }
        })
        .catch((json) => {
          console.log("handleSave", json);
          if (json.error !== config.hardCoded.queryCancelled) {
            console.groupCollapsed("API ERROR");
            console.error("JSON ->", json);
            console.groupEnd();

            let snackbarPayload = {
              ...user.screen.snackbar,
              open: true,
              message: json.error || config.hardCoded.uiErrorMessage,
            };
            ReduxDispatcher(updateUserScreen("snackbar", snackbarPayload));
          }
        });
    }
  };

  const handleAlertEnds = (value) => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "AlertManager",
      action: "AlertEndsIn",
      label: value,
    });

    // reducer dispatch action with value
    const payload = { key: "duration", value };
    const action = updateAlertForm(payload);
    dispatch(action);
  };

  const handleAlertType = (value) => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "AlertManager",
      action: "AlertType",
      label: value,
    });
    // reducer dispatch action with value
    const payload = { key: "alertType", value };
    const action = updateAlertForm(payload);
    dispatch(action);
  };

  const handlelanguageChange = (value) => {
    // reducer dispatch action with value
    const payload = { key: "userPreferredLanguage", value };
    const action = updateAlertForm(payload);
    dispatch(action);
  };

  const handleAlertStatus = (e, value) => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "AlertManager",
      action: "AlertStatus",
      label: "DetailPage",
    });

    // console.log("value of sigview switch", value);
    const payload = { key: "active", value };
    const action = updateAlertForm(payload);
    dispatch(action);
  };

  const handleFrequencyBasis = (newValue) => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "AlertManager",
      action: "AlertFrequency",
      label: newValue,
    });

    // reducer dispatch action with value
    const payload = {
      key: "basis",
      value: newValue,
    };
    const action = updateAlertForm(payload);
    dispatch(action);
  };

  const handleAlertNavChange = (value) => {
    // Google Analytics Event - Master
    masterTrackGaEvent({
      category: "AlertManager",
      action: "AlertNav",
      label: value,
    });

    setActiveAlertNav(value);
  };

  // Defining required variables for the AlertCriteria row props
  const AlertCriteriaRowProps = {
    changeCriteria: alertFormData.alertCriteriaMetric.data.changeCriteria,
    allMetrics: getAllPlotlyMetrics(allData),
    logicalConditionData:
      alertFormData.alertCriteriaMetric.data.logicalCondition.data,
    condition: alertFormData.alertCriteriaMetric.data.condition,
    state,
    showError,
  };

  // conditional rendering variable for Alert type
  const activeMetric = state.alertType.value;
  const activeDimension = state.alertType.value;

  // console.log(
  //   "AlertManagerForm",
  //   state,
  //   state.alertCriteriaDimension.value.conditionValue.validConditionValue
  // );
  // conditional rendering for alert dimension row
  // Defining required components
  const AlertFrequencyRow = () => {
    return (
      <>
        <AlertManagerFormRowItem
          title={t("Frequency:")}
          style={{
            inputContainer: true,
            borderLess: true,
            commonSet: true,
          }}
        >
          <SigviewSingleSelect
            value={state.timeZone.value}
            data={alertFormData.timeZone.data}
            onChange={(newValue) => {
              // reducer dispatch action with value
              const payload = {
                key: "timeZone",
                value: newValue,
              };
              const action = updateAlertForm(payload);
              dispatch(action);
            }}
            margin={{ right: "5px" }}
            minWidth="110px"
            width="140px"
            height="33px"
            fontSize="12px"
            // backgroundColor={`${themeColors["primaryColor"]}1A`}
            backgroundColor="#EEEFF2"
            border="none"
            borderRadius="4px"
          />
          <SigviewTypography
            style={{
              height: "max-content",
              padding: "4px 0px 0px 0px",
            }}
            variant="pMedium"
          >
            On
          </SigviewTypography>
          <SigviewSingleSelect
            value={state.basis.value}
            data={
              state.alertCriteriaDimension.value.dimensionRow.value !== "change"
                ? alertFormData.basis.data.filter((el) => el.id === "daily")
                : alertFormData.basis.data
            }
            onChange={(newValue) => handleFrequencyBasis(newValue)}
            margin={{ right: "5px", left: "5px" }}
            minWidth="110px"
            width="140px"
            height="33px"
            fontSize="12px"
            border="none"
            borderRadius="4px"
            // backgroundColor={`${themeColors["primaryColor"]}1A`}
            backgroundColor="#EEEFF2"
          />
          <SigviewTypography
            style={{
              height: "max-content",
              padding: "4px 0px 0px 0px",
            }}
            variant="pMedium"
          >
            Basis
          </SigviewTypography>
        </AlertManagerFormRowItem>
        {/* <AlertManagerFormRowItem
          style={{ inputContainer: true, borderLess: true }}
        >
          <Box
            css={{
              height: "25px",
              display: "flex",
              alignItems: "center",
              marginTop: "11px",
            }}
          >
            <SigviewSingleSelect
              value={state.basis.value}
              data={
                state.alertCriteriaDimension.value.dimensionRow.value !==
                "change"
                  ? alertFormData.basis.data.filter((el) => el.id === "daily")
                  : alertFormData.basis.data
              }
              onChange={(newValue) => handleFrequencyBasis(newValue)}
              margin={{ right: "5px", left: "5px" }}
              minWidth="140px"
              height="28px"
              fontSize="11px"
              border="1px solid #edf1ff"
              backgroundColor="#fff"
              customClassName={`Alert${state.basis.value}-GA`}
            />
          </Box>
        </AlertManagerFormRowItem>

        <AlertManagerFormRowItem style={{ borderLess: true }}>
          <Box
            css={{
              height: "25px",
              display: "flex",
              alignItems: "center",
              marginTop: "11px",
            }}
          >
            <SigviewTypography
              style={{
                height: "max-content",
                padding: "2px",
              }}
              variant="pSmallMedium"
            >
              Basis
            </SigviewTypography>
          </Box>
        </AlertManagerFormRowItem> */}

        {(state.alertType.value === "dimension" &&
          state.alertCriteriaDimension.value.changeCriteria.value ===
            "percentageChange" && (
            <>
              <AlertManagerFormRowItem
                title={t("Compared with")}
                style={{
                  inputContainer: true,
                  borderLess: true,
                  comparedWith: true,
                }}
              >
                {(state.basis.value === "daily" && (
                  <Box
                    css={{
                      // height: "25px",
                      display: "flex",
                      alignItems: "center",
                      //marginTop: "11px",
                    }}
                  >
                    <SigviewSingleSelect
                      value={state.comparedWith.value}
                      data={alertFormData.comparedWith.onDailyBasis}
                      onChange={(newValue) => {
                        // reducer dispatch action with value
                        const payload = {
                          key: "comparedWith",
                          value: newValue,
                        };
                        const action = updateAlertForm(payload);
                        dispatch(action);
                      }}
                      minWidth="140px"
                      height="33px"
                      fontSize="12px"
                      border="none"
                      // backgroundColor={`${themeColors["primaryColor"]}1A`}
                      backgroundColor="#EEEFF2"
                    />
                  </Box>
                )) ||
                  (state.basis.value === "hourly" && (
                    <Box
                      css={{
                        // height: "25px",
                        display: "flex",
                        alignItems: "center",
                        //marginTop: "11px",
                      }}
                    >
                      <SigviewSingleSelect
                        value={state.comparedWith.value}
                        data={alertFormData.comparedWith.onHourlyBasis}
                        onChange={(newValue) => {
                          // reducer dispatch action with value
                          const payload = {
                            key: "comparedWith",
                            value: newValue,
                          };
                          const action = updateAlertForm(payload);
                          dispatch(action);
                        }}
                        minWidth="140px"
                        height="33px"
                        fontSize="12px"
                        border="none"
                        // backgroundColor={`${themeColors["primaryColor"]}1A`}
                        backgroundColor="#EEEFF2"
                      />
                    </Box>
                  ))}
              </AlertManagerFormRowItem>
            </>
          )) ||
          (state.alertType.value === "dimension" &&
            state.alertCriteriaDimension.value.dimensionRow.value === "add" && (
              <AlertManagerFormRowItem
                title={t("Compared with")}
                style={{
                  inputContainer: true,
                  borderLess: true,
                  comparedWith: true,
                }}
              >
                <Box
                  css={{
                    // height: "25px",
                    display: "flex",
                    alignItems: "center",
                    //marginTop: "11px",
                  }}
                >
                  <SigviewSingleSelect
                    value={state.comparedWith.value}
                    data={alertFormData.comparedWith.onDailyBasis}
                    onChange={(newValue) => {
                      // reducer dispatch action with value
                      const payload = {
                        key: "comparedWith",
                        value: newValue,
                      };
                      const action = updateAlertForm(payload);
                      dispatch(action);
                    }}
                    minWidth="140px"
                    height="33px"
                    fontSize="12px"
                    border="none"
                    // backgroundColor={`${themeColors["primaryColor"]}1A`}
                    backgroundColor="#EEEFF2"
                  />
                </Box>
              </AlertManagerFormRowItem>
            )) ||
          (state.alertType.value === "dimension" &&
            state.alertCriteriaDimension.value.dimensionRow.value ===
              "delete" && (
              <AlertManagerFormRowItem
                title={t("Compared with")}
                style={{
                  inputContainer: true,
                  borderLess: true,
                  comparedWith: true,
                }}
              >
                <Box
                  css={{
                    // height: "25px",
                    display: "flex",
                    alignItems: "center",
                    //marginTop: "11px",
                  }}
                >
                  <SigviewSingleSelect
                    value={state.comparedWith.value}
                    data={alertFormData.comparedWith.onDailyBasis}
                    onChange={(newValue) => {
                      // reducer dispatch action with value
                      const payload = {
                        key: "comparedWith",
                        value: newValue,
                      };
                      const action = updateAlertForm(payload);
                      dispatch(action);
                    }}
                    minWidth="140px"
                    height="33px"
                    fontSize="12px"
                    border="none"
                    // backgroundColor={`${themeColors["primaryColor"]}1A`}
                    backgroundColor="#EEEFF2"
                  />
                </Box>
              </AlertManagerFormRowItem>
            ))}

        {/* {state.alertType.value === "dimension" &&
          state.alertCriteriaDimension.value.dimensionRow === "add" && (
            <AlertManagerFormRowItem
              title={t("Compared with")}
              style={{
                inputContainer: true,
                borderLess: true,
                comparedWith: true,
              }}
            ></AlertManagerFormRowItem>
          )} */}
        {state.alertType.value === "metric" &&
          state.alertCriteriaMetric.value.find(
            (el) => el.changeCriteria?.value === "percentageChange"
          ) && (
            <>
              <AlertManagerFormRowItem
                title={t("Compared with:")}
                style={{
                  inputContainer: true,
                  borderLess: true,
                  comparedWith: true,
                }}
              >
                {(state.basis.value === "daily" && (
                  <Box
                    css={{
                      // height: "25px",
                      display: "flex",
                      alignItems: "center",
                      // marginTop: "11px",
                    }}
                  >
                    <SigviewSingleSelect
                      value={state.comparedWith.value}
                      data={alertFormData.comparedWith.onDailyBasis}
                      onChange={(newValue) => {
                        // reducer dispatch action with value
                        const payload = {
                          key: "comparedWith",
                          value: newValue,
                        };
                        const action = updateAlertForm(payload);
                        dispatch(action);
                      }}
                      minWidth="140px"
                      height="33px"
                      fontSize="12px"
                      border="none"
                      // backgroundColor={`${themeColors["primaryColor"]}1A`}
                      backgroundColor="#EEEFF2"
                    />
                  </Box>
                )) ||
                  (state.basis.value === "hourly" && (
                    <Box
                      css={{
                        // height: "25px",
                        display: "flex",
                        alignItems: "center",
                        // marginTop: "11px",
                      }}
                    >
                      <SigviewSingleSelect
                        value={state.comparedWith.value}
                        data={alertFormData.comparedWith.onHourlyBasis}
                        onChange={(newValue) => {
                          // reducer dispatch action with value
                          const payload = {
                            key: "comparedWith",
                            value: newValue,
                          };
                          const action = updateAlertForm(payload);
                          dispatch(action);
                        }}
                        minWidth="140px"
                        height="33px"
                        fontSize="12px"
                        border="none"
                        // backgroundColor={`${themeColors["primaryColor"]}1A`}
                        backgroundColor="#EEEFF2"
                      />
                    </Box>
                  ))}
              </AlertManagerFormRowItem>
            </>
          )}
      </>
    );
  };

  //* Defining required variables
  const navDataFinal = [
    { id: "details", name: "Details", disabled: false },
    { id: "summary", name: "Summary", disabled: validate },
  ];
  // save button disable logic
  const isFormInvalidFlag = validateAlertFormData(state); //not state
  const isShowErrorVisible = showError.flag; //state ->

  const isSaveDisabled = !isFormInvalidFlag
    ? false
    : isShowErrorVisible
    ? true
    : false; //not state
  const updateAlertFlag = isEqual(state, alertFormDataOriginal.current);

  // update button disable logic - commenting because of bug need to be always enabled
  // const isUpdateDisabled = updateAlertFlag
  //   ? true
  //   : isFormInvalidFlag
  //   ? true
  //   : false;

  const isUpdateDisabled = false;

  const atleastOneFilterSelected = state.dimensionFilters.value.length > 0;

  // Defining required variables for the alert manager summary props
  const alertManagerSummaryProps = {
    state,
    allData,
  };
  return (
    <>
      <div className="alerts-form">
        <div className="alerts-content-main">
          <Box className="alerts-details-box">
            <SigviewTypography
              variant="heading"
              style={{ fontSize: "20px", margin: "0.3em 0px 0.5em !important" }}
            >
              Details
            </SigviewTypography>
            {/* Name row */}
            <Box
              style={{
                border: "1px solid #E4E2DE",
                boxSizing: "border-box",
                borderRadius: "8px",
                padding: "14px",
              }}
            >
              <AlertManagerFormRow>
                <AlertManagerFormRowItem
                  title={t("Name:")}
                  style={{
                    full: true,
                    inputContainer: true,
                    borderLessName: true,
                    commonSet: true,
                  }}
                >
                  <SigviewTextField
                    onChange={(value) => {
                      if (value !== " ") {
                        // reducer dispatch action with value
                        const payload = { key: "name", value };
                        const action = updateAlertForm(payload);
                        dispatch(action);
                      }
                    }}
                    border="none"
                    borderRadius="4px"
                    height="33px"
                    // backgroundColor={`${themeColors["primaryColor"]}1A`}
                    backgroundColor="#EEEFF2"
                    value={state.name.value}
                    maxWidth="100%"
                    fontSize="12px"
                    helperText={validateNameMessage(state.name.value)}
                    error={validateName}
                  />
                </AlertManagerFormRowItem>
              </AlertManagerFormRow>
              {/* Alert type row */}
              <AlertManagerFormRow style={{ frequencyItemContainer: true }}>
                <AlertManagerFormRowItem
                  title={t("Alert Type:")}
                  style={{
                    inputContainer: true,
                    borderLess: true,
                    commonSet: true,
                  }}
                >
                  <SigviewRadioGroup
                    value={state.alertType.value}
                    data={alertFormData.alertType.data}
                    onChange={(value) => handleAlertType(value)}
                    customClassName={`Alert${state.alertType.value}-GA`}
                    style={{
                      // backgroundColor: `${themeColors["primaryColor"]}1A`,
                      backgroundColor: "#EEEFF2",
                      borderRadius: "4px",
                      fontSize: "12px",
                      padding: "4.5px 10px 4.5px 6px",
                    }}
                  />
                </AlertManagerFormRowItem>
                <AlertManagerFormRowItem
                  title={t("Alert Ends in:")}
                  style={{ alertEndsWidth: true, radioBtnGroup: true }}
                >
                  <SigviewRadioGroup
                    data={alertFormData.duration.data}
                    onChange={(value) => handleAlertEnds(value)}
                    value={state.duration.value}
                    style={{
                      // backgroundColor: `${themeColors["primaryColor"]}1A`,
                      backgroundColor: "#EEEFF2",
                      borderRadius: "4px",
                      fontSize: "12px",
                      padding: "4.5px 10px 4.5px 6px",
                    }}
                  />
                </AlertManagerFormRowItem>

                <AlertManagerFormRowItem
                  title={t("Alert Status:")}
                  style={{
                    alertStatus: true,
                    radioBtnGroup: true,
                    commonSet: true,
                  }}
                >
                  {/*  TODO: */}
                  <SigviewTypography
                    style={{
                      height: "max-content",
                      margin: "0px 5px 0px 0px !important",
                      fontWeight: !state.active.value && "500",
                      color: !state.active.value
                        ? themeColors["primaryColor"]
                        : themeColors["secondaryColor"],
                    }}
                  >
                    In-active
                  </SigviewTypography>
                  <SigviewSwitch
                    name={"Alert Status:"}
                    customClassName="AlertON-OFF-GA"
                    checked={state.active.value}
                    margin={{ left: "5px" }}
                    fontSize="12px"
                    onChange={(e, value = !state.active.value) => {
                      handleAlertStatus(e, value);
                    }}
                  />
                  <SigviewTypography
                    style={{
                      height: "max-content",
                      margin: "0px 0px 0px 5px !important",
                      fontWeight: state.active.value && "500",
                      color: state.active.value
                        ? themeColors["primaryColor"]
                        : themeColors["secondaryColor"],
                    }}
                  >
                    Active
                  </SigviewTypography>
                </AlertManagerFormRowItem>
              </AlertManagerFormRow>
              {/* Alert Me Metric Row */}
              {activeMetric === "metric" && (
                <AlertManagerFormRow>
                  <AlertManagerFormRowItem title={t("Alert Me:")}>
                    <AlertCriteriaComponent
                      {...AlertCriteriaRowProps}
                      onChange={(value) => {
                        // reducer dispatch action with value
                        const payload = {
                          key: "alertCriteriaMetric",
                          value,
                        };
                        const action = updateAlertForm(payload);

                        dispatch(action);
                      }}
                    />
                  </AlertManagerFormRowItem>
                </AlertManagerFormRow>
              )}
              {/* Alert Me Dimension Row */}
              {activeDimension === "dimension" && (
                <AlertManagerFormRow>
                  <AlertDimension
                    dispatch={dispatch}
                    state={state}
                    allData={allData}
                    validMetric={validMetric}
                    showError={showError}
                    validDimension={validDimension}
                    validConditionValue={validConditionValue}
                    // validConditionValue={validConditionValue}
                  />
                </AlertManagerFormRow>
              )}
              {/* Frequency row */}
              <AlertManagerFormRow
                style={{ frequencyItemContainer: true, commonSet: true }}
              >
                <AlertFrequencyRow />
              </AlertManagerFormRow>
              {/* Filter row */}
              <AlertManagerFormRow>
                <AlertManagerFormRowItem
                  title={t("Filters:")}
                  buttonFlag={true}
                  buttonProps={{
                    iconProps: {
                      className: "material-icons-round",
                      iconName: "add_circle",
                    },
                    title: "Add filters",
                    onClick: handleAddFilters,
                  }}
                >
                  {/* <SigviewButton
                    variant="contained"
                    title="Add Filters"
                    onClick={handleAddFilters}
                  /> */}
                  <div className="alerts-input-item-container transparent alerts-filterBox">
                    {!atleastOneFilterSelected && (
                      <SigviewTypography
                        variant="pMedium"
                        style={{
                          color: `${themeColors["secondaryColor"]}`,
                          height: "max-content",
                        }}
                      >
                        No filters added
                      </SigviewTypography>
                    )}
                    {atleastOneFilterSelected && (
                      <SelectedFilters
                        onClick={(row, type) => {
                          switch (type) {
                            case "dimension":
                              handleDimFilterClick(row);
                              break;
                            case "metric":
                            default:
                              break;
                          }
                        }}
                        onDelete={(row, type) => {
                          switch (type) {
                            case "dimension":
                              handleDimFilterDelete(row);
                              break;
                            case "metric":
                            default:
                              break;
                          }
                        }}
                        showClearAllButton={true}
                        onClearAll={handleClearAllFilters}
                        // rowHeader="Applied Filters:"
                        selectedDimensionFilters={state.dimensionFilters.value}
                        selectedMetricFilters={[]}
                        style={{ maxHeight: "62px", margin: "3px" }}
                        divId="filtersMenuBarRow"
                        allData={allData}
                        // childrenPlacement="start"
                      ></SelectedFilters>
                    )}
                  </div>
                </AlertManagerFormRowItem>
              </AlertManagerFormRow>

              {/* User LanguagePreference row */}
              <AlertManagerFormRow>
                {sigviewUserType === "nonSigview" && (
                  <AlertManagerFormRowItem title={t("Preferred Language:")}>
                    <SigviewSingleSelect
                      value={state.userPreferredLanguage.value}
                      data={
                        user.reqMetadata.organization === "OpenX"
                          ? alertFormData.languageOptionsArr.NonSigview
                          : alertFormData.languageOptionsArr.Sigview
                      }
                      onChange={(value) => {
                        handlelanguageChange(value);
                      }}
                      minWidth="110px"
                      width="140px"
                      height="33px"
                      fontSize="12px"
                      border="none"
                      borderRadius="4px"
                      // backgroundColor={`${themeColors["primaryColor"]}1A`}
                      backgroundColor="#EEEFF2"
                      disabled={false}
                    />
                  </AlertManagerFormRowItem>
                )}
              </AlertManagerFormRow>
              {/* Email rec row */}
              <AlertManagerFormRow>
                <AlertManagerFormRowItem title={t("Email Recipients:")}>
                  <SigviewInputTags
                    inputValidationFunction={validateEmail}
                    data={state.emailRecipients.value}
                    border="none"
                    onChange={(value) => {
                      // reducer dispatch action with value
                      const payload = { key: "emailRecipients", value };
                      const action = updateAlertForm(payload);
                      dispatch(action);
                    }}
                  />
                </AlertManagerFormRowItem>
              </AlertManagerFormRow>
            </Box>
          </Box>
          <Box className="alerts-summary-box">
            <SigviewTypography
              variant="heading"
              style={{ fontSize: "20px", margin: "0.3em 0px 0.5em !important" }}
            >
              Summary
            </SigviewTypography>
            <Box
              style={{
                // backgroundColor: `${themeColors["primaryColor"]}1A`,
                backgroundColor: "#EEEFF2",
                boxSizing: "border-box",
                borderRadius: "8px",
                padding: "14px",
              }}
            >
              <AlertManagerSummary {...alertManagerSummaryProps} />
            </Box>
          </Box>
        </div>
        <div className="alerts-content-menu-bar" id="reportFormMenuBar">
          <div className="alerts-left-panel-footer"></div>
          <div className="alerts-right-panel-footer">
            <SigviewButton
              variant="outlined"
              onClick={handleCancel}
              title="Cancel"
              style={{ margin: { right: "5px" } }}
              customClassName="AlertCancel-GA"
            />
            {state.crudOperation.value === "update" && (
              <SigviewButton
                variant="contained"
                onClick={handleDelete}
                title="Delete"
                style={{ margin: { right: "5px" } }}
                customClassName="AlertDelete-GA"
              />
            )}
            {state.crudOperation.value === "update" && (
              <SigviewButton
                variant="contained"
                onClick={handleUpdate}
                title="Update"
                style={{ margin: { right: "5px" } }}
                disabled={isUpdateDisabled}
                customClassName="AlertUpdate-GA"
              />
            )}
            {state.crudOperation.value === "create" && (
              <SigviewButton
                variant="contained"
                // onClick={handleAddSaveAlert}
                onClick={handleSave}
                title="Save"
                style={{ margin: { right: "5px" } }}
                disabled={isSaveDisabled}
                customClassName="AlertSave-GA"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AlertManagerForm;
